import { parseCanonicalSlug } from './slugValidation';

export type ViewerRouteKind = 'admin' | 'preview' | 'live' | 'unknown';

export interface ViewerRouteContext {
  kind: ViewerRouteKind;
  companyId: string | null;
  productId: string | null;
  previewToken: string | null;
  isCanonical: boolean;
}

export function getViewerRouteContext(locationLike?: string | URL | Location): ViewerRouteContext {
  const fallback: ViewerRouteContext = {
    kind: 'unknown',
    companyId: null,
    productId: null,
    previewToken: null,
    isCanonical: false,
  };

  const url = (() => {
    try {
      if (typeof URL !== 'function') {
        return null;
      }

      if (!locationLike) {
        if (typeof window === 'undefined') return null;
        return new URL(window.location.href);
      }

      if (typeof locationLike === 'string') return new URL(locationLike);
      if (locationLike instanceof URL) return locationLike;
      return new URL(locationLike.href);
    } catch {
      return null;
    }
  })();

  if (!url) return fallback;

  const parts = url.pathname.split('/').filter(Boolean);
  if (parts[0] !== 'viewer') {
    return fallback;
  }

  const kind = parts[1];
  if (kind !== 'admin' && kind !== 'preview' && kind !== 'live') {
    return fallback;
  }

  const companyId = parseCanonicalSlug(parts[2]);
  const productId = parseCanonicalSlug(parts[3]);

  if (!companyId || !productId) {
    return fallback;
  }

  return {
    kind,
    companyId,
    productId,
    previewToken: url.searchParams.get('token'),
    isCanonical: true,
  };
}
